import Translator from '../../classes/Translator/Translator';

const OurProjectsLogic = () => {
    const { translator } = Translator();

    return {
        translator,
    };
};

export default OurProjectsLogic;
